import {RateOptionViewModel} from "../../../../../domain/common/odds/rate-option/models/rate-option.view-model";
import {observable, computed, override} from "mobx";
import {BaseModuleState} from "../../../../../infrastructure/models/base-module-state";
import {OddsFactory} from "../../../../../domain/common/odds/domain-services/odds.factory";
import {OddsViewModel} from "../../../../../domain/common/odds/models/odds.view-model";
import {FullGameDataSource} from "../../../../../domain/full-game/models/full-game-data-source";
import {BookmakerViewModel} from "../../../../../domain/common/bookmaker/models/bookmaker-view-model";
import {CurrentOddsModuleConfig} from "../current-odds-module.config";
import {AppStore} from "../../../../../core/app/app-store";
import {LoggerUtils} from "../../../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../../../core/models/device.view-model";
import {TermsUtils} from "../../../../../infrastructure/utils/terms-utils";
import {contractsUtils} from "../../../../../infrastructure/utils/contracts-utils";
import {NavigationManager} from "../../../../../core/managers/navigation-manager";
import {BaseMobxState} from "../../../../../infrastructure/mobx/base-mobx-state";
import {EXTRA_LINKS_CONTEXTS} from "../../../../../core/app/consts";
import type {OddsDomainModel} from "../../../../../domain/common/odds/models/odds.domain-model";

export class CurrentOddsModuleState extends BaseModuleState {
  dataSource: FullGameDataSource;
  @observable menuOpen: Boolean;
  oddsFactory: OddsFactory;

  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, CurrentOddsModuleConfig, OddsFactory];

  constructor(
    navigationManager: NavigationManager,
    appStore: AppStore,
    logger: LoggerUtils,
    datetimeUtils: DatetimeUtils,
    device: DeviceViewModel,
    termsUtils: TermsUtils,
    config: CurrentOddsModuleConfig,
    oddsFactory: OddsFactory
  ) {
    super(navigationManager, appStore, logger, datetimeUtils, device, termsUtils, config);

    contractsUtils.requiredType(oddsFactory, OddsFactory);

    this.menuOpen = false;
    this.oddsFactory = oddsFactory;
  }

  @computed get selectedOddsType() {
    return this.appState.currentOddsType;
  }

  @override get isPopulated(): Boolean {
    const isPopulated: Boolean = super.isPopulated && this.dataSource?.game.currentOdds && this.dataSource?.game.currentOdds.length;

    return isPopulated;
  }

  @computed get gameId(): Number {
    return this.dataSource?.game.id;
  }

  @computed get statusGroup(): Number {
    return this.dataSource?.game.statusGroup;
  }

  @computed get odds(): OddsViewModel {
    const currentOdds = this.dataSource?.game.currentOdds?.find((odds: OddsDomainModel) => odds.bookmaker.id === this.appState.topBookmakerId) || this.dataSource?.game.currentOdds?.first();
    const odds: OddsViewModel = this.oddsFactory.createVM(currentOdds, this.selectedOddsType, EXTRA_LINKS_CONTEXTS.liveOdds);

    return odds;
  }

  @computed get currentRates(): Array<RateOptionViewModel>{
    const hasRates = !!this.odds.rateOptions && !!this.odds.rateOptions.length;

    return hasRates && this.odds.rateOptions;
  }

  get hasValidCurrentRates(): Boolean {
    let hasValidCurrentRates: Boolean = false;
    this.odds.rateOptions?.forEach((rate) => hasValidCurrentRates |= rate.isCurrentRateValid)

    return Boolean(hasValidCurrentRates);
  }

  @computed get bookmaker(): BookmakerViewModel{
    return this.odds.bookmaker;
  }

  get hasValidPreMatchRates(): Boolean {
    let hasValidPreMatchRates: Boolean = false;
    this.odds.rateOptions?.forEach((rate) =>  hasValidPreMatchRates |= rate.isPreMatchRateValid)

    return hasValidPreMatchRates;
  }

  @computed get hasPreMatchOdds(): BookmakerViewModel {
    return this.currentRates && !!this.currentRates[0].preMatchRates && this.hasValidPreMatchRates;
  }

  @computed get isOnlyPreMatchOdds(): Boolean {
    return this.hasValidPreMatchRates && !this.hasValidCurrentRates;
  }

  @computed get sportTypeId(): Number {
    return this.dataSource.game?.sport.id;
  }
}
